import type { AuthorizationInfo } from '@cimpress-technology/authfront-sdk-core'

const OCI_BASE_URL = 'https://oauth.cimpress.io'
// Legacy identity keys, used only for legacy tenants (see LEGACY_TENANTS).
const BASE_KEYS = {
  CODE_VERIFIER: 'vp-code-verifier',
  REFERENCE_TOKEN_COOKIE_KEY: 'vpsession',
  REFRESH_TOKEN_COOKIE_KEY: 'vpauth',
  REFERENCE_TOKEN_TYPE_COOKIE_KEY: 'vpsession-type',
  TOKEN_DETAILS_STORAGE_KEY: 'vp-token-details',
  CONFIG: 'vpconfig'
}
// New identity keys, used for all non-legacy tenants.
const NEW_KEYS = {
  CODE_VERIFIER: 'af_cv',
  REFERENCE_TOKEN_COOKIE_KEY: 'af_at',
  REFRESH_TOKEN_COOKIE_KEY: 'af_rt',
  REFERENCE_TOKEN_TYPE_COOKIE_KEY: 'af_att',
  TOKEN_DETAILS_STORAGE_KEY: 'af_td',
  CONFIG: 'af_cfg'
}
// Tenants that continue to use the legacy identity keys; all others use the new keys.
const LEGACY_TENANTS = ['vistaprint', 'vistaprintpro', 'proshop']
const TOKEN_CLAIMS = {
  WAS_TOKEN_CLAIM: 'https://claims.cimpress.io/was',
  CANONICAL_ID_TOKEN_CLAIM: 'https://claims.cimpress.io/canonical_id',
  IS_ANONYMOUS_TOKEN_CLAIM: 'https://claims.cimpress.io/is_anonymous',
  CIMPRESS_INTERNAL_CLAIM: 'https://claims.cimpress.io/cimpress_internal',
  CUSTOMER_CLAIM: 'https://claims.cimpress.io/is_customer',
}

const JWT_TOKEN_TYPE = 'Bearer'
const OPTIMIZELY_COOKIE_NAME = 'optimizelyEndUserId'
const TEST_COOKIE_NAME = 'testUserId'
const DEFAULT_ANON_REFRESH_TOKEN_LIFETIME_IN_SEC = 365 * 24 * 60 * 60
const DEFAULT_USER_REFRESH_TOKEN_LIFETIME_IN_SEC = 30 * 24 * 60 * 60
const PLS_COOKIE_NAME = '_pls'
const VP_CONFIG_DOMAIN = 'oauth.cimpress.io'
const TENANT_DOMAIN_RESOLVE_URL = 'https://api.experience.cimpress.io/tenants/v1/resolve'
const LOCALE_RESOLVE_URL = 'https://url.prod.merch.vpsvc.com/v3/url'
const EMPTY_IDENTITY = {
  profile: null,
  accessToken: null,
  referenceToken: null,
  isSignedIn: false,
  canonicalId: null,
  authorizationHeader: null,
  recentAnonymousIds: [],
  authorization: {} as AuthorizationInfo
}

export {
  OCI_BASE_URL,
  JWT_TOKEN_TYPE,
  OPTIMIZELY_COOKIE_NAME,
  TEST_COOKIE_NAME,
  DEFAULT_ANON_REFRESH_TOKEN_LIFETIME_IN_SEC,
  DEFAULT_USER_REFRESH_TOKEN_LIFETIME_IN_SEC,
  PLS_COOKIE_NAME,
  VP_CONFIG_DOMAIN,
  TENANT_DOMAIN_RESOLVE_URL,
  LOCALE_RESOLVE_URL,
  EMPTY_IDENTITY,
  BASE_KEYS,
  NEW_KEYS,
  TOKEN_CLAIMS,
  LEGACY_TENANTS
}
